import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import addModal from './addModal.vue';
import { translateList, translateDelete } from './request';
export default {
  components: {
    addModal
  },
  data() {
    const h = this.$createElement;
    return {
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        page: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      form: {
        language: 'zh'
      },
      addVisible: false,
      isEdit: false,
      tableData: [{
        id: 1
      }],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80,
        align: 'center'
      }, {
        slots: {
          title: '标签名称'
        },
        dataIndex: 'signName',
        key: 'signName',
        align: 'center',
        width: 180,
        ellipsis: true,
        customRender: (text, record) => h("a-tooltip", {
          "attrs": {
            "placement": "topLeft",
            "title": record.signName
          }
        }, [record.signName])
      }, {
        slots: {
          title: '生成时间'
        },
        dataIndex: 'createAt',
        key: 'createAt',
        align: 'center',
        width: 180,
        ellipsis: true,
        customRender: (text, record) => h("a-tooltip", {
          "attrs": {
            "placement": "topLeft",
            "title": record.createAt
          }
        }, [record.createAt])
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: 'updateAt',
        align: 'center',
        width: 180,
        ellipsis: true,
        customRender: (text, record) => h("a-tooltip", {
          "attrs": {
            "placement": "topLeft",
            "title": record.updateAt
          }
        }, [record.updateAt])
      }, {
        slots: {
          title: '操作人'
        },
        dataIndex: 'nickName',
        key: 'nickName',
        width: 160,
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 180,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      language: [{
        name: '简体中文',
        key: 'zh'
      }, {
        name: '繁體中文',
        key: 'cht'
      }, {
        name: 'English',
        key: 'en'
      }, {
        name: 'español',
        key: 'spa'
      }, {
        name: 'Français',
        key: 'fra'
      }
      // {name: 'Русский язык', key: 'ru'}
      ]
    };
  },
  created() {
    this.insertLangColumn();
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.pagination.current = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await translateList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
    },
    openAddModal(value) {
      this.isEdit = value;
      this.addVisible = true;
    },
    onDelete(id) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该标签？'), {
        confirmButtonText: this.$t('确定')
      }).then(async () => {
        await translateDelete({
          signId: id
        });
        _this.$message.success(this.$t('删除成功'));
        _this.getListData();
      });
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    },
    insertLangColumn() {
      const h = this.$createElement;
      let langColumn = [];
      this.language.map(item => {
        let obj = {
          slots: {
            title: item.name
          },
          dataIndex: item.key,
          key: item.key,
          align: 'center',
          width: 180,
          ellipsis: true,
          customRender: (text, record) => h("a-tooltip", {
            "attrs": {
              "placement": "topLeft",
              "title": record[item.key]
            }
          }, [record[item.key]])
        };
        langColumn.push(obj);
      });
      this.columns.splice(2, 0, ...langColumn);
    },
    reset() {
      this.form = {
        language: 'zh'
      };
    }
  }
};